import api from './index';

const createMessage = (params) => api.raw.post('/send_messages/', params);

export default {
    createMessage
}